var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"terms__agree"},[_c('IconComponent',{attrs:{"name":"tick-circle"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n    Согласен с\n    "),_c('a',{attrs:{"href":"/static/documents/4_Пользовательское_соглашение.pdf","target":"_blank"}},[_vm._v("пользовательским соглашением")])])
}]

export { render, staticRenderFns }